import baseAPI from './axiosApi'
import qs from 'qs'

const api={
    nav:'/api-u/menus/me',
    allNav:'/api-u/menus/tree',
    todoList: '/api-ir/todo/list',
}


//获取用户拥有权限的菜单树
export function getNav (id) {
    if(id=='')
    {
        return baseAPI.axiosData(api.nav,'get')
    }
    else
    {
        return baseAPI.axiosData(api.nav,'get',{parentId:id})
    }
}
//获取菜单列表
export function getAllNav () {
    return baseAPI.axiosData(api.allNav, 'get', )
}

//待办列表
export function todoList () {
    return baseAPI.axiosData(api.todoList,'get')
}